import React from 'react'

export default function NotSignedIn() {
  return (
    <div className='ms-2'>You are not logged in. Please Login or Create an Account by clicking on the above button</div>
  )
}
